<template>
  <v-card id="tax-fondos-acciones" class="px-4 pt-2 pb-4 my-0 elevation-0">
    <v-card-title class="px-1">
      <h1 class="card-title">
        Fondos de inversión, Acciones, ETFs, Derechos, Bonos, Criptodivisas
      </h1>
    </v-card-title>

    <v-card-text class="mt-0 pt-0 pb-3 px-3">
      <v-row>
        <v-col cols="12" md="12" class="px-4">
          <TaxTitle title="Fondos de inversión" />
          <v-alert
            v-if="
              fondosAcciones.boxes.funds &&
              fondosAcciones.boxes.funds.data &&
              fondosAcciones.boxes.funds.data.entidades &&
              fondosAcciones.boxes.funds.data.entidades.length
            "
            color="softInfo"
            icon="mdi-alert"
            class="mt-4 mb-5"
          >
            En esta sección, listamos los fondos junto con su ISIN para poder reconocerlos. Sin
            embargo, en la casilla de la Entidad emisora (311) NO se debe incluir el ISIN en la
            declaración de la renta. En caso de fondos españoles se debe incluir el NIF. En caso de
            fondos no españoles, se puede dejar en blanco.
          </v-alert>
          <EntidadesTable
            :entidades="fondosAcciones.boxes.funds"
            positionType="fund"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </v-col>

        <v-col cols="12" md="12" class="px-4">
          <TaxTitle
            title="Acciones y ETF (GyP patrimoniales derivadas de transmisiones de acciones negociadas)"
            infoIconText="Esta sección incluye la información de acciones y de ETF"
          />
          <EntidadesTable
            :entidades="fondosAcciones.boxes.stocks"
            positionType="stock"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </v-col>

        <v-col cols="12" md="12" class="px-4">
          <TaxTitle
            title="Derechos (GyP patrimoniales derivadas de transmisiones de derechos de suscripción)"
          />
          <EntidadesTable
            :entidades="fondosAcciones.boxes.rights"
            positionType="right"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </v-col>

        <template v-if="yearSelected >= 2022">
          <v-col cols="12" md="12" class="px-4">
            <TaxTitle
              title="Cripto (GyP patrimoniales derivadas de la transmisión o permuta de monedas virtuales por particulares)"
            />
            <EntidadesTable
              :entidades="fondosAcciones.boxes.cryptos"
              positionType="crypto"
              :hideDataNoPlanUser="hideDataNoPlanUser"
            />
          </v-col>
        </template>

        <v-col cols="12" md="12" class="px-4">
          <TaxTitle title="Bonos" />
          <EntidadesTable
            :entidades="fondosAcciones.boxes.bonds"
            positionType="bond"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TaxTitle from '@/views/components/tax/taxDocs/renta/TaxTitle'
import EntidadesTable from '@/views/components/tax/taxDocs/renta/EntidadesTable'

export default {
  components: { TaxTitle, EntidadesTable },
  props: {
    fondosAcciones: {
      type: Object,
      default: () => {},
    },
    yearSelected: {
      type: String,
      default: null,
    },
    hideDataNoPlanUser: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
#tax-fondos-acciones {
  .items-flex {
    display: flex;
    align-items: center;
  }
}
</style>
